import { useEffect, useState } from 'react'
import type { DrawLottery } from '@nexbit/types'
import { apiAgentGetNumberLimitHistory, apiDrawGetLotteries } from '@/lib/api'
import { NumberLimitHistoryTable } from '@/components/number-limit-history-table'

/**
 * ประวัติการอั้นเลข (เอเย่นต์) — the record of this agent's own rules.
 *
 * Its own only. The server takes the agent from the session and forces the agent scope,
 * so this screen cannot be pointed at another agent's book or at the house's. The house's
 * limits are not hidden from an agent — the ปิดรับเลข screen shows them as the "ของบ้าน"
 * column, which is the part an agent works with — but its *history* would name which
 * admin changed what and when, which is not the agent's business.
 *
 * Useful even to an agent who sets its own rules, because more than one person logs in
 * with one agent's credentials: "who capped 45 at 200 last Tuesday" is a question an
 * agent asks about its own book.
 */
export default function AgentNumberHistoryPage() {
  const [lotteries, setLotteries] = useState<DrawLottery[]>([])

  useEffect(() => {
    let alive = true
    void (async () => {
      try {
        const data = await apiDrawGetLotteries()
        if (alive) setLotteries(data)
      } catch {
        // The หวย filter is skipped; the history itself still loads.
      }
    })()
    return () => { alive = false }
  }, [])

  return (
    <div className="p-4 md:p-6 max-w-7xl">
      <div className="mb-4">
        <h1 className="text-lg font-semibold tracking-tight">ประวัติการอั้นเลข</h1>
        <p className="text-sm text-muted-foreground mt-0.5">
          กฎที่คุณตั้งไว้ทั้งหมด — ปิดรับเลข เพดานรับ และจ่ายลด ค้นหาย้อนหลังตามวันที่
        </p>
      </div>

      <NumberLimitHistoryTable
        fetchPage={apiAgentGetNumberLimitHistory}
        lotteries={lotteries}
        subtitle="กฎที่คุณเปลี่ยน"
        emptyHint="ประวัติจะขึ้นที่นี่เมื่อคุณตั้งหรือลบกฎในหน้า ปิดรับเลข"
      />
    </div>
  )
}
